module.exports={
    "10%满钻优惠": "10% uDiamonds bonus",
    "<%=count%>条新消息": "<%=count%>new messages",
    "<%=count%>经验值": "<%=count%> EXP",
    "<%=giftName%>最喜欢<%=giftName1%>和别人点它啦~点击<%=giftName%>或者送<%=giftName1%>礼物，可以帮助主播收服<%=giftName%>哦！": "<%=giftName%> favorite <%=giftName1%> and tap it! Tap <%=giftName%> or send <%=giftName1%> to the host to catch the <%=giftName%>",
    "<%=giftName%>最喜欢<%=giftName1%>和有人点它!快点帮助主播收服调皮的<%=giftName%>吧!快尝试一下！": "<%=giftName%> favorite <%=giftName1%> and tap it! Help the host to catch the naughty <%=giftName%>!",
    "<%=name%>以<%=money%>U钻价格，晋升为主播的守护": "<%=name%> used <%=money%> diamonds to become the host's Guardian Angel!",
    "<%=name%>的更多小视频": "More short videos of <%=name%>",
    "<%=name%>的直播间": "<%=name%>'s stream － Uplive , live it up",
    "<%=name%>被<%=label%><%=userName%>禁言": "<%=name%> has been banned from speaking by <%=label%><%=userName%>",
    "<%=name%>被<%=label%><%=userName%>移除直播间": "<%=name%> has been moved out of the room by <%=label%><%=userName%>",
    "<%=name%>被<%=label%><%=userName%>解除禁言": "<%=name%>has been released from banned speaking by <%=label%><%=userName%>",
    "<%=name%>被主播任命为场控": "<%=name%>is named as room admin by the host",
    "<%=name%>被主播移除场控身份": "The host dismissed the Room Admin <%=name%>",
    "<%=name%>被禁言": "<%=name%> is banned to chat.",
    "<%=name%>被移出直播间": "<%=name%> has been removed from this chat room.",
    "<%=name%>被解除禁言": "<%=name%> 's ban on chatting is released.",
    "<%=name%>进入了房间": "<%=name%> enters the chat room",
    "<%=name%>进入直播间": "<%=name%> enter the chat room",
    "<%=num%>分钟前": "<%=num%> minutes ago",
    "<%=num%>天前": "<%=num%> days ago",
    "<%=num%>小时前": "<%=num%> hours ago",
    "<%=num%>年前": "<%=num%> years ago",
    "<%=num%>月前": "<%=num%> months ago",
    "<%=sname%>悄悄@<%=rname%>": "<%=sname%>Poke@<%=rname%>",
    "<%=userName%>坐着<%=carName%>进入了直播间": "Welcome <%=userName%> enter the chatting room on <%=carName%>",
    "<em>Hi,<%=name%>,</em>没有找到心仪的主播？来看看我吧~": "<em>Hi,<%=name%></em>, haven't found your ideal host yet? Come check me out~",
    "<em>Hi,<%=name%>,</em>送你一个<b>小礼物</b>,快来跟我互动吧": "<em>Hi,<%=name%>, </em> sent you a <b>small gift</b>, come chat!",
    "<em>登录</em>之后即可进行充值": "<em>Login</em>in order to recharge",
    "@TA": "@User",
    "AD": "Andorra",
    "AE": "United Arab Emirates",
    "AF": "Afghanistan",
    "AG": "Antigua and Barbuda",
    "AI": "Anguilla",
    "AL": "Albania",
    "AM": "Armenia",
    "AN": "Netherlands Antilles",
    "AO": "Angola",
    "AQ": "Antarctica",
    "AR": "Argentina",
    "AS": "American Samoa",
    "AT": "Austria",
    "AU": "Australia",
    "AW": "Aruba",
    "AZ": "Azerbaijan",
    "Android下载": "Android download",
    "BA": "Bosnia and Herzegovina",
    "BB": "Barbados",
    "BD": "Bangladesh",
    "BE": "Belgium",
    "BF": "Burkina Faso",
    "BG": "Bulgaria",
    "BH": "Bahrain",
    "BI": "Burundi",
    "BJ": "Benin",
    "BL": "Saint Barthelemy",
    "BM": "Bermuda",
    "BN": "Brunei",
    "BO": "Bolivia",
    "BR": "Brazil",
    "BS": "Bahamas",
    "BT": "Bhutan",
    "BW": "Botswana",
    "BY": "Belarus",
    "BZ": "Belize",
    "CA": "Canada",
    "CC": "Cocos Islands",
    "CD": "Democratic Republic of the Congo",
    "CF": "Central African Republic",
    "CG": "Republic of the Congo",
    "CH": "Switzerland",
    "CI": "Ivory Coast",
    "CK": "Cook Islands",
    "CL": "Chile",
    "CM": "Cameroon",
    "CN": "China",
    "CO": "Colombia",
    "CR": "Costa Rica",
    "CU": "Cuba",
    "CV": "Cape Verde",
    "CW": "Curacao",
    "CX": "Christmas Islands",
    "CY": "Cyprus",
    "CZ": "Czech Republic",
    "DE": "Germany",
    "DJ": "Djibouti",
    "DK": "Denmark",
    "DM": "Dominica",
    "DO": "Dominican Republic",
    "DZ": "Algeria",
    "EC": "Ecuador",
    "EE": "Estonia",
    "EG": "Egypt",
    "EH": "Western Sahara",
    "ER": "Eritrea",
    "ES": "Spain",
    "ET": "Ethiopia",
    "FI": "Finland",
    "FJ": "Fiji",
    "FK": "Falkland Islands",
    "FM": "Micronesia",
    "FO": "Faroe Islands",
    "FR": "France",
    "GA": "Gabon",
    "GB": "United Kingdom",
    "GD": "Grenada",
    "GE": "Georgia",
    "GG": "Guernsey",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GIFTO余额不足": "Insufficient GIFTO",
    "GL": "Greenland",
    "GM": "Gambia",
    "GN": "Guinea",
    "GQ": "Equatorial Guinea",
    "GR": "Greece",
    "GT": "Guatemala",
    "GTO": "GTO",
    "GU": "Guam",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "Google Play": "Google Play",
    "HK": "Hong Kong",
    "HN": "Honduras",
    "HR": "Croatia",
    "HT": "Haiti",
    "HU": "Hungary",
    "ID": "Indonesia",
    "IE": "Ireland",
    "IL": "Israel",
    "IM": "Isle of Man",
    "IN": "India",
    "INTELLECTUAL PROPERTY RIGHTS": "INTELLECTUAL PROPERTY RIGHTS",
    "IO": "British Indian Ocean Territory",
    "IQ": "Iraq",
    "IR": "Iran",
    "IS": "Iceland",
    "IT": "Italy",
    "JE": "Jersey",
    "JM": "Jamaica",
    "JO": "Jordan",
    "JP": "Japan",
    "KE": "Kenya",
    "KG": "Kyrgyzstan",
    "KH": "Cambodia",
    "KI": "Kiribati",
    "KM": "Comoros",
    "KN": "Saint Kitts and Nevis",
    "KP": "North Korea",
    "KR": "South Korea",
    "KW": "Kuwait",
    "KY": "Cayman Islands",
    "KZ": "Kazakhstan",
    "LA": "Laos",
    "LB": "Lebanon",
    "LC": "Saint Lucia",
    "LI": "Liechtenstein",
    "LK": "Sri Lanka",
    "LR": "Liberia",
    "LS": "Lesotho",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "LV": "Latvia",
    "LY": "Libya",
    "Line": "Line",
    "MA": "Morocco",
    "MC": "Monaco",
    "MD": "Moldova",
    "ME": "Montenegro",
    "MF": "Saint Martin",
    "MG": "Madagascar",
    "MH": "Marshall Islands",
    "MK": "Macedonia",
    "ML": "Mali",
    "MM": "Myanmar",
    "MN": "Mongolia",
    "MO": "Macau",
    "MP": "Northern Mariana Islands",
    "MR": "Mauritania",
    "MS": "Montserrat",
    "MSL": "the Middle East",
    "MT": "Malta",
    "MU": "Mauritius",
    "MV": "Maldives",
    "MW": "Malawi",
    "MX": "Mexico",
    "MY": "Malaysia",
    "MYC": "\nMalay Chinese Region",
    "MYNC": "Malay Non-Chinese Region",
    "MZ": "Mozambique",
    "NA": "Namibia",
    "NC": "New Caledonia",
    "NE": "Niger",
    "NG": "Nigeria",
    "NI": "Nicaragua",
    "NL": "Netherlands",
    "NO": "Norway",
    "NP": "Nepal",
    "NR": "Nauru",
    "NU": "Niue",
    "NZ": "New Zealand",
    "OM": "Oman",
    "PA": "Panama",
    "PE": "Peru",
    "PF": "French Polynesia",
    "PG": "Papua New Guinea",
    "PH": "Philippines",
    "PK": "Pakistan",
    "PL": "Poland",
    "PM": "Saint Pierre and Miquelon",
    "PN": "Pitcairn",
    "PR": "Puerto Rico",
    "PS": "Palestine",
    "PT": "Portugal",
    "PW": "Palau",
    "PY": "Paraguay",
    "Privacy Policy": "Privacy Policy",
    "QA": "Qatar",
    "RE": "Reunion",
    "RO": "Romania",
    "RS": "Serbia",
    "RU": "Russia",
    "RW": "Rwanda",
    "SA": "Saudi Arabia",
    "SB": "Solomon Islands",
    "SC": "Seychelles",
    "SD": "Sudan",
    "SE": "Sweden",
    "SG": "Singapore",
    "SH": "Saint Helena",
    "SI": "Slovenia",
    "SJ": "Svalbard and Jan Mayen",
    "SK": "Slovakia",
    "SL": "Sierra Leone",
    "SM": "San Marino",
    "SN": "Senegal",
    "SO": "Somalia",
    "SR": "Suriname",
    "SS": "South Sudan",
    "ST": "Sao Tome and Principe",
    "SV": "El Salvador",
    "SX": "Sint Maarten",
    "SY": "Syria",
    "SZ": "Swaziland",
    "TC": "Turks and Caicos Islands",
    "TD": "Chad",
    "TG": "Togo",
    "TH": "Thailand",
    "TJ": "Tajikistan",
    "TK": "Tokelau",
    "TL": "East Timor",
    "TM": "Turkmenistan",
    "TN": "Tunisia",
    "TO": "Tonga",
    "TR": "Turkey",
    "TT": "Trinidad and Tobago",
    "TV": "Tuvalu",
    "TW": "Taiwan",
    "TZ": "Tanzania",
    "Terms of Service": "Terms of Service",
    "UA": "Ukraine",
    "UG": "Uganda",
    "US": "United States",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "Up号": "Up account",
    "Up号:<%=code%>": "Up account:<%=code%>",
    "Up直播-直播全世界": "Uplive - Live it UP!",
    "Up直播网页版不支持红包功能，请您下载Up直播 App版本体验更多有趣功能！": "This feature is not avaible. please download Uplive to get this red packet.",
    "U币": "Coins",
    "U币余额不足": "Insufficient coin balance",
    "U币兑换": "U coin exchange",
    "U币贡献榜": "Top Fans",
    "U钻": "Diamond",
    "U钻余额": "Balance",
    "U钻充值": "Udiamond recharge",
    "U钻兑换失败，请稍候重试": "Diamond exchange failed, please try again",
    "U钻兑换成功": "Diamond exchange successful",
    "VA": "Vatican",
    "VC": "Saint Vincent and the Grenadines",
    "VE": "Venezuela",
    "VG": "British Virgin Islands",
    "VI": "U.S. Virgin Islands",
    "VIP_level_1": 6000,
    "VIP_level_10": 12000000,
    "VIP_level_2": 30000,
    "VIP_level_3": 60000,
    "VIP_level_4": 120000,
    "VIP_level_5": 300000,
    "VIP_level_6": 600000,
    "VIP_level_7": 1200000,
    "VIP_level_8": 3000000,
    "VIP_level_9": 6000000,
    "VIP_recharge_1": 10000,
    "VIP_recharge_10": 20000000,
    "VIP_recharge_2": 50000,
    "VIP_recharge_3": 100000,
    "VIP_recharge_4": 200000,
    "VIP_recharge_5": 500000,
    "VIP_recharge_6": 1000000,
    "VIP_recharge_7": 2000000,
    "VIP_recharge_8": 5000000,
    "VIP_recharge_9": 10000000,
    "VIP介绍": "VIP membership",
    "VIP保级要求-": "VIP maintain requirement-",
    "VIP充值": "VIP Top-up",
    "VIP充值要求-": "VIP recharge requirement-",
    "VIP勋章": "VIP badge",
    "VIP勋章特权说明": "VIP badge shows your honorable status",
    "VIP勋章获取条件": "VIP1 or higher",
    "VIP客服": "VIP customer service",
    "VIP形容内容": "VIP is a distinguish status with a series of privileges like special animated swagger, free whispering, etc.",
    "VIP是什么": "What is VIP",
    "VIP有效时间：<%=time%>": "VIP valid period: <%=time%>",
    "VIP特权": "VIP privilege",
    "VIP特权介绍": "VIP privileges details",
    "VIP特权内容": "1. Exclusive VIP customer service to resolve any issues quickly @@@@ 2. One-to-one customer service specialist for each VIP user @@@@ 3. VIP special effects when entering a broadcast room @@@@ 4. Whisper is free",
    "VIP用户在个人主页、聊天室等将有不一样的个人展示。": "Distinctive logo for VIP shown in chat room, personal page",
    "VIP用户进入聊天室，会有不一样的入场特效！": "Enjoy distinctive animation entry effect",
    "VIP用户，悄悄话全部免费使用呦！": "Free whisper for VIP",
    "VIP的升级/保级体系": "VIP levelling up / maintaining system",
    "VIP的升级/保级体系内容": "@@@@To maintain your VIP level, you need to recharge the required amount in the next month. Qualified monthly recharge extends your VIP level for one month. Not doing so will decrease your VIP level by one. For example, if you are VIP1 this month, and you failed to maintain your VIP level, your level will decrease to VIP0 next month, that means you will lose your VIP status.",
    "VIP的升级/保级体系内容_bak": "VIP levelling up / maintaining system details",
    "VIP等级": "VIP Level",
    "VIP等级及对应充值额度": "VIP Level and diamonds required",
    "VIP等级特权": "VIP level privileges",
    "VIP获得方式": "How to obtain VIP status",
    "VIP获得方式内容": "1. You will be rewarded VIP status of tier @@@@ based on the diamonds purchased within a calendar month 2. Purchasing diamonds is the only way to obtain and level up VIP status to ",
    "VIP规则": "VIP Rules",
    "VIP规则内容": "1. After a user has obtained VIP status, a certain amount of diamond purchases within the calendar month is required to maintain the status for next month @@@@ 2. VIP users can perform actions on non-VIP users such as silencing them and banning them from a live stream",
    "VIP规则说明": "VIP rule explanation",
    "VIP规则说明内容": "@@@@ Monthly recharge amount is calculated at 00:00 of the 1st day of the month@@@@ If your monthly recharge amount meets the requirment, your VIP valid period will be extended for one month@@@@If your monthly recharge amount doesn't meet the requirment, your VIP level will be reduced by 1 level; If you happen to be a VIP1, you will lose your VIP idenfication.",
    "VN": "Vietnam",
    "VU": "Vanuatu",
    "W Motors莱肯": "Lykan HyperSport",
    "WF": "Wallis and Futuna",
    "WS": "Samoa",
    "XK": "Kosovo",
    "YE": "Yemen",
    "YT": "Mayotte",
    "ZA": "South Africa",
    "ZM": "Zambia",
    "ZW": "Zimbabwe",
    "app": "App",
    "banner": "You got an invitation to test new VIP function!\n03/02/2017",
    "codapay": "Codapay",
    "contact.html": "/up-contact/index.html",
    "convention.html": "/up-doc/convention_en.html",
    "danalpay": "DanalPay",
    "facebook.html": "https://www.facebook.com/uplivecam",
    "iOS下载": "App Store",
    "iPhone下载": "iPhone download",
    "icard_Code": "Code",
    "icard_Serial": "Serial",
    "icard_cardType": "CardType",
    "icard_cardValue": "CardValue",
    "icard_popup_confirm_title": "The information below is correct?",
    "icard_popup_no": "No",
    "icard_popup_yes": "Yes",
    "molpay_credit_card": "MOLPay Credit Card",
    "molpay_points": "zGOLD-MOLPoints",
    "mycard": "MyCard",
    "onecard": "OneCard",
    "paypal": "Paypal",
    "paytm": "Paytm",
    "pepay_entitycard": "CashCard(IDR)",
    "pepay_entitycard_vnd": "CashCardVND)",
    "pepay_onlinebank": "OnlineBank(IDR)",
    "pepay_onlinebank_vnd": "OnlineBank(VND)",
    "privacy.html": "/up-doc/privacy_en.html",
    "protocol.html": "/up-doc/protocol_en.html",
    "ta还没写签名呢，告诉ta?": "Tell them to write something about themselves!",
    "ta还没有签名呢，告诉ta?": "This user's status is empty, go tell them to write one!",
    "terms.html": "/up-doc/terms_en.html",
    "“不开森...没有拿够<%=giftName1%>”,<%=giftName%>失落的离开了直播间!下次努力": "\"So sad... <%=giftName1%> is not enough\"，<%=giftName%> left the room, do better next time!",
    "一个神秘的地方": "A mysterious place",
    "一条弹幕1U钻": "1 bullet message = 1 diamond",
    "一条弹幕<%=count%>U钻": "<%=count%>U diamond/danmu",
    "一段时间内禁止他人在此聊天室发布信息，过了禁言时间后才能重新发言。": "Ban someone from speaking for a certain period of time in this chat room",
    "上一小时": "Last Hour",
    "上周": "Last Week",
    "上周星榜": "Last week",
    "上月": "Previous month",
    "下一步": "Next",
    "下单失败": "Order failed",
    "下载": "Download",
    "下载 APP": "Download App",
    "下载Up直播APP": "Download Uplive App",
    "下载客户端": "Download Client",
    "下载客户端app领取分享红包": "Download client app to claim share red packets",
    "不能频繁发送邮件": "Can't send mail too frequently",
    "专一的守护，他所有的特权只对守护的主播生效": "3. Guardian Privileges are only valid for this particular host",
    "专享客服": "Enhanced customer service",
    "专属入场特效": "Premium animation effect",
    "专属弹幕": "Exclusive bullet messages ",
    "专属弹幕特权说明": "Exclusive VIP bullet messaging",
    "专属弹幕获取条件": "VIP7 or higher",
    "专属礼物": "Exclusive gifts",
    "专属礼物特权说明": "VIP exclusive customized gifts. Special gifts for special you!",
    "专属礼物获取条件": "VIP2 or higher",
    "个人主页": "Personal",
    "个人信息设定失败": "Fail to save",
    "个人信息设定成功": "Saved success",
    "个人资料": "Profile",
    "为保证您的账户和财产安全，请绑定手机号": "To protect the security of your account and personal data, please bind your phone number to your account",
    "主播": "Host",
    "主播可能在休息，稍后再来试试吧": "The host is having a rest, please check later",
    "主播回来了，视频即将恢复！": "Host is back!",
    "主播暂时离开了，小伙伴们请稍候。": "Host has temporarily left the room, please wait a bit",
    "主播榜": "Host board",
    "主播榜单": "Host Rank",
    "主播的守护天使<%=name%>，进入直播间，掌声在哪里！": "The host's Guardian Angel <%=name%> has entered the chat room, please give a round of applause!",
    "主页": "Profile",
    "举报": "Report",
    "举报失败": "Report failed",
    "举报成功": "Report successful",
    "了解VIP等级及特权": "View VIP level and privileges ",
    "互相关注即可成为好友哦~": "If you follow each other, you will become friends!",
    "亚洲创新集团出品": "Asia Innovations Group Limited's product",
    "亲爱的<%=name%><br/>这么喜欢我，小礼物走一走呗～": "<%=name%><br/>Surprise the host by sending a gift",
    "今日可提现金额": "Daily available balance :",
    "付款遇到问题？点击联系客服": "Experiencing payment problems? Click here to contact customer service",
    "余额不足情况下，充值提醒的描述": "Please recharge",
    "你也可以花费更高的价钱，将自己守护的时间重新变为4天": "You can also pay a higher price and renew your guardianship to 4 days.",
    "你关注的人现在没有开播": "Followed host isn't streaming currently",
    "你关注的人还没有直播": "None of your followings is boardcasting.",
    "你已经将<%=name%>禁言": "You've banned <%=name%> from speaking",
    "你已经将<%=name%>移除直播间": "You've moved <%=name%> out from this room",
    "你已经将<%=name%>解除禁言": "You've released <%=name%> from banned speaking",
    "你来晚了，已经被抢完了，下次加油": "You are too late...Nothing left.",
    "你来晚了，红包已经发放完了, 下次加油！": "You are too late...Nothing left.",
    "你没有权限进行该操作": "You don't have permission to do this",
    "你现在是游客身份": "You are currently in visitor mode",
    "你的发言频率太快，休息一下吧！": "You are sending too many chat messages, please take a break!",
    "你的禁言时间已到，自动解除禁言": "Your ban on speaking has expired and you can now comment again",
    "你的账号未绑定任何信息，请绑定后再进行此操作": "Your account has not bound any other accounts, please bind then try again",
    "你确定要消耗<%=count%>U钻帮助主播收服小精灵吗？": "Spend <%=count%> diamond to help the host catch the Little Monster, ok?",
    "你被<%=userName%>禁言<%=time%>分钟": "You've been banned from speaking for <%=time%> minutes by <%=userName%>",
    "你赠送礼物的U钻将会随机分给领取礼物的人": "The diamonds from the gift you sent will be randomly distributed to users who got the gift",
    "使用CashCard充值所得U钻数将根据兑换比例(<%=currence%><%=real%>=<%=number%>钻)进行换算，最终所得U钻数会进行四舍五入处理": "uDiamonds amount obtained by using CashCard recharge will be converted according to conversion ratio (<%=currence%><%=real%>=<%=number%>uDiamonds), and the final uDiamonds amount will be rounded off.",
    "使用CashCard充值的金额数以点卡实际支付的金额为准": "Money amount recharged using CashCard is based on the amount actually paid by point card.",
    "保存": "Save",
    "保级成功，下月可继续尊享<%=grade%>，本月再充值<%=count%>U钻可升级为<%=grade1%>，尊享更多特权": "You have maintained your level. You’ll continue enjoying<%=grade%> next month. Recharge <%=count%> more uDiamonds in this month to level up to <%=grade1%> and enjoy more privileges.",
    "保级要求(U钻)": "Maintenance requirement (uDiamonds)",
    "充值": "Recharge",
    "充值成功": "Recharge successfully",
    "充值数量": "Recharge amount",
    "充值方式": "Recharge option",
    "充值档位参考": "Recharge tier reference",
    "充值比例: <%=currence%><%=real%>=<%=number%>U钻": "Conversion Ratio: <%=currence%><%=real%>=<%=number%>uDiamonds",
    "充值要求(U钻)": "Recharge requirement (uDiamonds)",
    "充值遇到问题,点此": "If experiened with recharge problems, please click here",
    "免费下载": "Free download",
    "免费悄悄话": "Free private messages",
    "免费悄悄话特权说明": "Free private messages in chat rooms",
    "免费悄悄话获取条件": "VIP1 or higher",
    "全区广播": "Public broadcast",
    "全区广播1000U钻": "Global speak: 1000 diamond",
    "全区广播<%=count%>U钻": "Radio <%=count%>U diamond",
    "全部": "View all",
    "全部提现": "Withdraw All",
    "全部游戏类型": "All game genres",
    "兰博基尼Huracan": "Lamborghini Huracan",
    "关于我们": "About Us",
    "关于我们内容": "Uplive, founded in May 2016, has powerful international resources, excellent host resources and worldwide user groups, focuses on establishing an international Live Platform, which is a talent agency of instant online celebrities and models with special background, involving best content creation and top host resources.",
    "关注": "Follow",
    "关注了主播，从此不再错过。": "followed this host",
    "关注动词": "Follow",
    "关注成功": "Followed successfully",
    "关注成功，已解除拉黑": "Followed successfully, removed from blacklist",
    "关注隐身": "Invisible follow",
    "关注隐身特权说明": "Make your follow invisible on the fan list of your host. Take care of your host silently",
    "关注隐身获取条件": "VIP5 or higher",
    "其他": "Others",
    "其他用户花费更高的价钱，将会顶替你成为主播的守护天使": "4. Other users can pay a higher price to replace the current guardian.",
    "其他登录方式": "Other login method",
    "再试一次": "Try again",
    "写个签名吧，让大家了解你。": "Tell people about yourself",
    "分享": "Share",
    "分享失败": "Share failed",
    "分享成功": "Share successfully",
    "刚刚": "Just now",
    "删除该聊天": "Delete this chat",
    "别太贪心，你已经领取过了": "You've taken it already! Don't be greedy.",
    "刷一下": "Refresh",
    "剩余<%=count%>分": "Remaining <%=count%> Minutes",
    "剩余<%=count%>天": "Remaining <%=count%> Days",
    "剩余<%=count%>小时": "Remaining <%=count%> Hours",
    "剩余<%=count%>秒": "Remaining <%=count%> Seconds",
    "剩余<%=time%>重置榜单": "<%=time%> remain to reset ranking",
    "剩余U钻": "Remaining uDiamonds",
    "加个好友吧。聊嗨了才能拉近你们的距离哦！": "Add as friend to chat anytime, get closer~",
    "加个好友吧，聊嗨了才能拉近你们的距离哦！": "Add friends to shorten your distance by chatting ",
    "加载中": "Loading…",
    "动态特权": "Status advantages ",
    "动态特权特权说明": "Being a VIP, your posts and comments will be highlighted in your VIP frame with lit VIP badge. ",
    "动态特权获取条件": "VIP1 or higher ",
    "劳斯莱斯幻影": "Rolls-Royce Phantom",
    "升級VIP10后的文案提示": "Congratulations! You have unlocked the highest VIP level. No renew needed for this month!",
    "去充值": "Recharge",
    "去看看其他主播": "Check other hosts",
    "去看看当前热门直播": "Browse hot content",
    "去绑定": "Bind cellphone",
    "去绑定Payoneer": "Bind Payoneer",
    "参数错误": "error",
    "发出了<%=count%>个<%=giftName%>，距离收服<%=targetGiftName%>又近了一步！": " just released <%=count%> <%=giftName%>, we are getting closer to catch <%=targetGiftName%>!",
    "发现": "Discover",
    "发言太频繁了，请稍后再试": "You are posting too frequently, please try again later",
    "发言底纹": "Message background ",
    "发言底纹特权说明": "Customized chat bubbles allow your messages stand out from the crowd",
    "发言底纹获取条件": "VIP1 or higher",
    "发送": "Send",
    "发送动态前，请先给您的账户绑定上手机号码信息": "Please bind phone number with your account before sending statues",
    "发送消息前，请先给您的账户绑定上手机号码信息": "Please bind phone number with your account before sending message  ",
    "发送空消息主播感受不到你的爱哒…": "Blank message not allowed",
    "发送验证码": "Send verification code",
    "取消": "Cancel",
    "可提现金额": "Withdrawal amount :",
    "可提现金额：": "Withdrawal amount :",
    "启用Flash Player": "Enable Flash Player",
    "周榜": "Weekly",
    "哎哟，页面不见了": "The page not available now",
    "哎哟，页面无法查看，请稍候再试": "The page not available now, please try again later",
    "回复": "Reply",
    "国家/地区": "Country/Region",
    "国家或地区": "Country/Region",
    "圣劳伦佐SD126": "Sanlorenzo SL 126",
    "圣劳伦佐SL118": "Sanlorenzo SL 118",
    "圣汐115 Sport Yacht": "Sunseeker 115 Sport Yacht",
    "圣汐131Yacht": "Sunseeker 131 Yacht",
    "在看": "Viewers",
    "场控": "Room Admin",
    "天": "Day",
    "头像边框": "Avatar Frame",
    "头像边框特权说明": "VIP users light up their avatar frame unlike anyone else",
    "头像边框获取条件": "VIP1 or higher",
    "女": "Female",
    "好可惜～差一点点就抓住了小精灵，下次努力吧！": "What a pity! You almost caught the Little Monster! Try harder next time!",
    "好的": "OK",
    "如何升级": "How to level up",
    "如何升级详情": "Send gifts to your favorite hosts! The more gifts you send, the faster you'll level up!@@@@Want to try being a host? A talented host levels up faster!",
    "如何成为VIP": "How to become VIP",
    "如何成为VIP内容": "@@@@Gain VIP status when your total monthly recharge meets the requirements. @@@@recharge is the only way to gain and increase your VIP level.",
    "如何成为VIP内容_bak": "How to become VIP details",
    "娱乐": "Entertainment",
    "娱乐现场": "Entertainment Scene",
    "守护": "Guardian",
    "守护天使在保护主播4天后，会悄然离去": "Guardianship will disappear after guarding host for 4 days ",
    "守护座驾": "Guardian Car",
    "守护标识": "Guardian Icon",
    "守护特权": "Guardian Privileges",
    "守护规则": "Guardian rules",
    "守护规则说明": "Guardian terms",
    "完成": "Complete",
    "官方充值客服": "Official Customer Service",
    "官方助手": "Uplive Assistant",
    "官方客服": "Official Customer Service",
    "定制V认证": "Exclusive Badge",
    "定制V认证特权说明": "This feature is not avaible. Check back soon!",
    "定制V认证特权说明暂不开放": "Contact customer service to get your exclusive badge when you obtained this privilege. The privilege is valid when your VIP status is active. The privilege will not be available when your VIP level decreases. ",
    "定制V认证获取条件": "VIP4 or higher",
    "宝马M3": "BMW M3",
    "宾利慕尚": "Mulsanne",
    "密码由6-20位数字和字母组成": "Password length 6-20 characters (Only numbers and letters allowed)",
    "密码登录": "Password Login",
    "将他人移除直播间": "Remove someone out of the chat room",
    "将聊天室内乱发言的用户移除直播间。": "Remove a person from the chat room.",
    "尊享超过专属特权本月再充值<%=count%>U钻可升级为<%=grade%>，": "Enjoy more exclusive privileges by recharge <%=count%> more uDiamonds and level up to <%=grade%>",
    "尊贵名片": "VIP name card",
    "尊贵名片特权说明": "Customized luxury info card exclusively for VIP, a symbol of honorable status",
    "尊贵名片获取条件": "VIP1 or higher",
    "小时榜": "Hourly",
    "小时榜进行中": "Hourly rank is ongoing",
    "小时榜进行中 <%=count%>": "Hourly rank is ongoing <%=count%>",
    "小视频": "Short video",
    "小贴士": "Tips",
    "屏蔽全部特效": "Hide all special effects",
    "屏蔽小礼物": "Hide all small gifts",
    "屏蔽所有礼物": "Hide all gift animations",
    "屏蔽进场特效": "Hide all entry effects",
    "屏蔽频道广播": "Hide all stream broadcasts ",
    "展开更多": "More",
    "已关注": "Followed",
    "已加赠<%=count%>U钻": "<%=count%>U diamonds offered",
    "已发放待领取": "To be collected",
    "已取消分享": "Cancel share",
    "已添加": "Added",
    "已绑定": "Bound",
    "已绑定Paypal账号": "Bound Paypal account",
    "已退回": "Returned",
    "已领取": "Collected",
    "已验证，确认登录": "Verified, confirm login",
    "布加迪威航": "Bugatti Veyron",
    "帐号冻结": "Your account is frozen",
    "帐号或密码错误": "Wrong account or password",
    "帮助主播削弱<%=giftName%><%=count%>点战斗力，距离收服<%=giftName%>又近了一步！": "tapped <%=giftName%> <%=count%> times to help catch the <%=giftName%>",
    "应付金额": "Recharge amount",
    "庞巴迪全球快车": "Global Express XRS",
    "弹幕": "Bullet comment",
    "当前小时": "This Hour",
    "当日": "Today",
    "当月充值额度：<%=num%>": "This month recharge amount：<%=num%>",
    "微信": "WeChat",
    "微信号": "WeChat ID",
    "微信搜索并关注“Up小助手”可领取红包": "Search and subscribe to Wechat channel: 'Up小助手' to get lucky money",
    "微信支付": "WeChat",
    "忘记密码": "Forget Password",
    "快点下载Uplive，观看付费直播吧~": "Download Uplive now and enjoy paid streams!",
    "快点下载Uplive，观看私密直播吧~": "Download Uplive now and enjoy private streams!",
    "性别": "Gender",
    "总榜": "Overall",
    "恭喜<%=userName%>在<%=hostName%>的<%=title%>中赢得最高奖励": "Congrats to <%=userName%> for getting the highest amount <%=title%> from <%=hostName%> ",
    "恭喜你": "Congratulations!",
    "恭喜你成为主播的守护，从此你就是主播的人啦！": "Congratulations on becoming the Guardian Angel of the host!",
    "恭喜你获得": "Congratulations!",
    "恭喜发财，红包拿走": "Congratulations!",
    "悄悄@<%=name%>": "Poke@<%=name%>",
    "悄悄话": "Whisper",
    "悄悄话免费": "Whispering is free",
    "您下个月VIP级别": "Your VIP level next month",
    "您已被禁言": "You have been forbiddened!",
    "您已被移出直播间，请稍后再试": "You've been removed from this room and you cannot enter it for a while, please try again later",
    "您正在向<%=name%>发送好友申请": "You have sent friend request to <%=name%>",
    "您的VIP等级": "Your VIP level",
    "您的提现请求已成功发起，系统会在72小时内完成审核并发放奖励！": "Your withdrawal request has been confirmed, the system will review within 72 hours and send reward.",
    "您的账号可能存在安全风险，请立刻绑定手机号码。": "Your account may have safety risk, please bind your phone number immediately.",
    "您的账号在其他终端登录成功": "Your account has logged in on an other phone",
    "您还不是VIP贵族": "You are not a VIP yet",
    "您还未激活该VIP等级": "You have not activated this VIP level",
    "您还未选中或发起聊天，快去跟好友聊一聊吧": "You don't have any chats yet, start one now!",
    "成功帮助主播收服了<%=giftName%>！<%=giftName%>开心的离开了直播间~": "caught <%=giftName%> successfully! <%=giftName%> left happily~",
    "我们提倡绿色直播，只有通过审核并被标记为优质的主播才可能出现在热门，如封面和直播内容含有涉黄、低俗、吸烟、暴露等情况，将会被封禁账号。网警将保持24小时在线审核与审查，请您遵守。": "Content relating to violence, smoking, drugs or pornography is strictly prohibited. Administrators will be patrolling 24/7 and any users found with such content will be banned.",
    "我是<%=name%>": "I am <%=name%>",
    "我的U钻": "Diamonds",
    "我的VIP": "My VIP",
    "我的主页": "My profile",
    "我的会员": "My membership",
    "我的关注": "My Follows",
    "我的守护": "My Guardian",
    "我的直播": "My live stream",
    "我的等级": "My level",
    "我的背包": "My backpack",
    "我的账户": "My Account",
    "我的进场特效": "My appearance effects",
    "我知道了": "Noted",
    "我领取了<%=hostName%>的<%=title%>，获得<%=count%>U钻": "I got <%=title%> from <%=hostName%>，aqcuiring <%=count%> diamonds.",
    "战斗力": "Power",
    "所有解释权归Up直播所有": "UpLive reserves its right of final explanation of all the provisions, terms and other contents in relation to the VIP membership.\n",
    "手机号": "Mobile phone number",
    "手机号:": "Mobile No.:",
    "手机号已被绑定，请更换手机号": "Phone number registed, please change a number",
    "手机号输入错误": "Phone number input error",
    "手机注册/登录": "Mobile Register / Login",
    "手机登录": "Mobile Login",
    "打开Up直播<br/>扫一扫登录": "Open Up live <br/> and scan to log in",
    "扫一扫<br/>下载Uplive": "Scan <br/> to download Uplive",
    "扫码下载Uplive客户端": "Scan QR code to download Uplive",
    "扫码登录": "QR Code Login",
    "抢夺守护": "Buy Guardian Angel position",
    "拉黑": "Add to Blacklist",
    "拉黑后在热门列表中无法看到ta的直播": "Streams won't appear in your hot list after blacklisting.",
    "拉黑后将解除你与ta的关注关系<br/>在热门列表中无法看到ta的直播": "Adding to blacklist will remove the following relationship between you and the host\\n You won't see the them in the hot list anymore",
    "拉黑失败": "Failed to add to blacklist",
    "拉黑成功": "Added successfully to black list",
    "拉黑提示": "Blacklist notes",
    "拥有特权(<%=count%>/<%=total%>)": "You have privileges (<%=count%>/<%=total%>)&lrm;",
    "按下Enter发送内容": "Press enter to send",
    "按下这个，就完成赠送礼物了！": "Tap to send this gift ",
    "换个姿势重来一次": "Retry in another way",
    "授权失败": "Authorization failed",
    "排行榜": "Ranking",
    "推荐上热一": "Recommend No. 1 on hot list",
    "推荐上热门特权说明": "Contact your VIP customer service to recommend you host for the number one spot on global or regional hot list. Note: official accounts or recommendations by other VIP have priorities. -VIP9: one hour global No. 1 recommendation per month. Three of one hour regional No.1 recommendation per month. -VIP10: five recommendations for global No. 1 per month. Three recommendations for regional No. 1 per month. Recommended hosts are featured for one hour. ",
    "推荐上热门获取条件": "VIP9 or higher",
    "提现确认": "Withdraw",
    "提现账户：": "Withdrawal Up Accounts：",
    "提现遇到问题？点击联系客服": "Problem withdrawaling money? Click to contact with Customer Service",
    "提现金额": "Withdrawal amount",
    "提现错误": "Withdraw Error!!!",
    "提示": "Reminder",
    "提示内容": "Since the VIP function is under beta testing, if you run into any problem, feel free contact to our customer service. We apologise for the inconvenience that this may cause.",
    "搜索": "Search",
    "支付失败": "Payment failed",
    "支付失败，请重新下单": "Payment fails, please apply for a new order",
    "支付宝": "Alipay",
    "支付渠道": "Payment Method",
    "支持数字、字母和下划线组合，不支持的纯数字组合，不可重复，长度6~16个字符": "Up account supports the combination of numbers, letters and underscores.It cannot be only numbers and must be of 5-16 characters.",
    "收到的U币": "Received coins",
    "收到礼物数:<%=count%>": "number of gifts received: <%=count%>",
    "收服": "Caught",
    "收益提现": "Revenue is raised",
    "收看精彩直播": "Watch live highlights",
    "收获<%=count%>U币": "Gain <%=count%> Ucoins",
    "收费资讯": "Payment Information",
    "收起更多": "Retract",
    "放出了一只<%=giftName%><%=icon%>，大家快来帮主播收服它吧！": "just released one <%=giftName%><%=icon%>, everyone come to help the host catch it!",
    "政策限制不允许观看": "This video is no longer available accoding to laws and policies",
    "新人推荐": "Rookie Recommendation",
    "新用户注册<b>送精美礼品</b><em>与主播即时互动</em>": "New users are<b>gifted rewards</b>when registered<em> Come and interact with hosts now</em>",
    "无": "None",
    "日榜": "Daily",
    "明星主播": "Star Host",
    "星榜": "Stars",
    "昨日": "Yesterday",
    "是否解除该用户的禁言": "Cancle mute on this user?",
    "昵称": "Nickname",
    "昵称不能出现敏感词": "This nickname contents sensitive words",
    "晋升通知": "Level up notification",
    "晋升通知特权说明": "Your leveling up triggers big announcement across the platform. You are in the spotlight!",
    "晋升通知获取条件": "VIP1 or higher",
    "普清": "Normal",
    "暂无好友申请": "No friend request",
    "暂无数据": "No data",
    "暂无礼物": "Currently no gifts",
    "暂无被拉黑用户": "No one is blacklisted",
    "暂无领取记录": "No withdrawal record",
    "更多": "More",
    "更多国家": "More Countries",
    "更多热门直播": "More featured streams",
    "更多特权持续增加中...": "More privileges coming soon...",
    "最新": "Newest",
    "最新开播": "Newest Stream",
    "最新直播": "New Live",
    "最热": "Hottest",
    "最长可输入12个汉字": "max 12 characters",
    "最长可输入32个汉字": "max 32 character",
    "月榜": "Monthly",
    "有效期至:<%=time%>": "Expiration:",
    "未收到邮件": "Not yet receive email",
    "未知错误": "Unknown Error",
    "未绑定手机号": "Mobile not registed",
    "本周": "This Week",
    "本周星榜": "This week",
    "本月": "This month",
    "本月不需要保级，再充值<%=count%>U钻可升级为<%=grade%>，尊享更多特权": "No renew necessary for this month. Recharge <%=count%> uDiamonds to level up to <%=grade%> and unlock more privileges!",
    "本月再充值<%=count%>U钻可升级为<%=grade%>，尊享超过专属特权": "Recharge <%=count%> uDiamonds to level up to <%=grade%>. Enjoy exclusive privileges.",
    "本月再充值<%=count%>U钻完成【保级】，下个月继续尊享<%=grade%>特权": "Recharge <%=count%> uDiamonds in this month to maintain your level, so that you will continue enjoying your <%=grade%> privileges next month",
    "来晚了，什么都没剩下给你": "You are too late.. nothing left.",
    "查看全部": "View all",
    "查看守护规则": "Guardian rules",
    "查看更多": "View more",
    "查看最新消息": "Scroll down to see new messages",
    "标准": "Standard",
    "榜单隐身": "Invisible ranking",
    "榜单隐身特权说明": "Set yourself invisible on contributors board of your host. Be a mysterious low key VIP!",
    "榜单隐身获取条件": "VIP3 or higher",
    "正在关注…": "Following…",
    "正在加载": "Loading",
    "正在注册": "Registering...",
    "正在登录": "Logging in...",
    "正在绑定...": "Binding...",
    "正在购买": "Purchasing...",
    "正在退出...": "Logging out...",
    "此帐号已绑定": "This account is already bound",
    "每个主播仅有一名专属的守护天使": "1. Each host only can have one Guardian Angel",
    "每人仅一次机会": "Only once for each user",
    "永久": "Permanent",
    "没发现此人，重新输入试试？": "This user was not found",
    "没有关注记录": "No follow record",
    "没有浏览记录？": "There aren't any browse record?",
    "法拉帝960": "Ferretti 960",
    "波音 787": "Boeing 787",
    "注册账号": "Register Account",
    "注销": "Logout",
    "注：部分尊贵特权暂未开放，敬请期待！": "Notice: Certain VIP privileges are not yet available, please stay tune!",
    "洋妞直播VIP简介": "Exotic stream VIP terms",
    "活动": "Events",
    "活动详情": "Detail",
    "浏览历史": "Browsing History",
    "消耗:": "Used:",
    "消费<%=count%>U钻": "Spend <%=count%> U diamonds",
    "添加": "Add",
    "添加好友": "Add friend",
    "清屏": "Clear Screen",
    "温馨提示": "Tips",
    "游客登录失败，请使用其他方式登录": "Visitor login failed, please try another way to login",
    "游戏": "Game",
    "游戏中心": "Game Center",
    "游戏直播": "Game Stream",
    "湾流G55": "Gulfstream G550",
    "点亮了": "liked this",
    "点亮数量": "Heart count",
    "点击加载更多": "Tap to load more",
    "点击启用 Flash Player": "Click to activate Flash Player",
    "点击特权图标可查看特权说明": "Click privilege icon to view details ",
    "热门": "Hot",
    "热门直播": "Featured Stream",
    "特效": "Special",
    "特权名称": "Privilege Name",
    "特权说明": "Privilege details",
    "特殊身份标示": "Dinstinctive icon",
    "玛莎拉蒂GranTurismo": "Maserati GranTurismo",
    "用户VIP权限不足": "Insufficient user VIP privileges",
    "由于你未进行充值，无法赠送礼物": "You can send gift without topping up",
    "申请发送成功": "Request sent successfully",
    "男": "Male",
    "登录": "Login",
    "登录 Uplive": "Login Uplive",
    "登录<em>Uplive</em>": "Login<em>Uplive</em>",
    "登录<em>并</em>领取": "Login<em>and</em>Claim",
    "登录Uplive": "Login Uplive",
    "登录之后即可进行充值": "You can recharge after login",
    "登录代表你接受Up直播《服务条款及隐私政策》": "Logging in means you agree UP Live's 《<i>terms of service</i> and <em> privacy policy </em>》",
    "登录后可随时关注主播动态": "Sign in to keep track of the anchor activity",
    "登录密码设置失败": "Failed to set password",
    "登录密码设置成功": "Password set successfully",
    "直接添加客服联系方式(微信/Line)进行充值，最高可享": "Directly add customer service's contact information (WeChat/Line) to recharge, and receive at most",
    "直接联系官方客服进行充值，选择档位越高，优惠力度越大。": "Directly contact customer service to recharge, the higher the selected tier, the better the discount!",
    "直播结束": "Live stream ended",
    "直播间有精灵时，才可以送该礼物哦！": "You cannot send gifts until the elf appears",
    "直播间礼物公告": "Live room gift announcement",
    "直播间禁言": "Ban messaging in room",
    "直播间禁言特权说明": "VIP users have message ban privilege. Higher level VIP users can ban more. <b>Note: Use your message ban privilege carefully. Your room admin privilege will be permanently removed if you abuse your power.</b>",
    "直播间禁言获取条件": "VIP1 or higher",
    "直播间踢人": "Remove users from chat rooms",
    "直播间踢人特权说明": "VIPs have the privilege to kick out other users from the room. Higher level VIPs can remove more users. <b>Note: Use your message ban privilege carefully. Your room admin privilege will be permanently removed if you abuse your power.</b>",
    "直播间踢人获取条件": "VIP2 or higher",
    "真遗憾": "So close!",
    "知道了": "OK",
    "确定": "Confirm",
    "确定使用<%=bill%>U币兑换<%=diamond%>U钻": "Are you sure you want to exchange <%=bill%> coins for <%=diamond%> diamonds?",
    "确定提现": "Confirm withdrawal",
    "确认": "Confirm",
    "确认举报<%=name%>吗": "Are you sure you want to report <%=name%>?",
    "确认绑定": "Confirm Bind",
    "确认退出Up直播？": "Are you sure you want to exit Uplive ?",
    "礼物": "Gift",
    "礼物不存在": "Gift does not exist ",
    "礼物助手": "Gift Assistant",
    "礼物是空的": "Gift is empty",
    "神秘礼物": "Mystery Gift",
    "禁止他人发言": "Ban someone from speaking ",
    "禁言会让这个用户在<%=time%>分钟内无法发言": "Mute user will silence them for <%=time%> minutes",
    "禁言次数": "Muted # users",
    "福利多多，玩的更嗨": "Plenty of benefits, plently of fun",
    "福特野马": "Ford Mustang",
    "私人客服": "Private customer service",
    "私人客服特权说明": "Exclusive private customer service 24/7 at your disposal",
    "私人客服获取条件": "VIP1 or higher",
    "私信": "Private message",
    "私播直播间人数达到上限": "Private broadcast audience reached limit",
    "空中客车 A380": "Airbus A380",
    "立即体验": "Try now~",
    "立即充值": "Recharge now",
    "立即充值，完成VIP<%=count%>保级": "Recharge now to maintain your VIP level",
    "立即充值，提升VIP等级": "Recharge now to increase your VIP level",
    "立即充值，激活VIP特权": "Recharge now to unlock VIP privileges ",
    "立即围观": "Check it Out",
    "第一次心动": "First Heartbeat",
    "等级福利": "User level privileges",
    "等级福利详情": "High level users will have a logo to distinguish their status.@@@@The higher your level, the more customized privileges you'll enjoy.",
    "签名": "Status",
    "签名不能出现敏感词": "Introduction contents sensitive words",
    "粉丝": "Followers",
    "精彩活动": "Events",
    "系统消息": "System message:",
    "系统错误": "System Error",
    "累计经验：<%=code%>": "Exp. accumulated: <%=code%>",
    "累计领取": "Total amount withdrawn to date",
    "红包": "Red Packet",
    "经验值<%=num%>": "<%=num%> Exp",
    "绑定": "Bind",
    "绑定后不能解绑，请仔细确认": "This action cannot be reversed, please confirm entered information",
    "绑定后开启更多特权，让你的账号更加安全": "More privilege available after binding, make your account safer",
    "绑定后，审核大概需要一天左右时间": "After binding, it usually requires a day for reviewing",
    "绑定失败": "Binding failed",
    "绑定微信": "Bind wechat",
    "绑定微信后扫码关注“Up小助手”领取红包": "Get your Uplive revenue after subscribe “Up小助手” ",
    "绑定微信失败": "Wechat bind failed",
    "绑定成功": "Bind success",
    "绑定手机号": "Bind phone number",
    "绑定手机号码": "Bind phone number",
    "绑定手机号码,有利于保护您的账号和资金安全": "Bind phone number for account privacy protection",
    "给大家发了<%=count%>个<%=giftName%>，大量U钻等你来抢，拼人品的时候到了！": "Send  <%=count%> <%=giftName%> in this room, free diamonds are waiting for you, be quick！",
    "编辑": "Edit",
    "网络连接有误, 请稍后再试": "Network issue, please try again later.",
    "聊天提醒": "Highlighted chat",
    "联系客服": "Contact customer service",
    "联系我们": "Contact us",
    "背包": "Backpack",
    "背包是空的": "Backpack is empty",
    "背包礼物过期": "Backpack gift expired",
    "花费:": "Cost：",
    "获取个人信息失败": "Fail to get your personal information",
    "获取手机验证码": "Get mobile verify code",
    "获取条件": "Requirements ",
    "获取用户信息失败, 请稍后再试": "Fail to load the data, please try later",
    "虚位以待": "Waiting for someone...",
    "观看": "Viewer",
    "观看人数": "Viewer count",
    "观看历史": "Watch History",
    "观看记录": "Watch history",
    "规则说明": "Explanation",
    "解除": "Remove",
    "解除拉黑": "Unblock",
    "解除拉黑失败": "Failed to remove from black list",
    "解除拉黑成功": "Removed from blacklist successfully",
    "认证:": "Verification:",
    "让全世界看到你的美": "Let the world see your beauty",
    "设置国家或地区失败": "Fail to set your country/region",
    "设置国家或地区成功": "Country/Region information updated!",
    "设置新密码": "Set New Password",
    "评论": "Comment",
    "评论成功": "Comment has been successfully posted",
    "评论最大长度140": "Please enter maximum 140 characters",
    "试试这个，主播会喜欢的！": "Tap to send this gift ",
    "该功能暂未开放，敬请期待！": "This feature is not avaible. Check back soon!",
    "该帐号已经注册过Up，是否切换此账号？": "This account has registered Up,switch this account?",
    "该手机号未被注册": "This mobile no. hasn't been registered yet",
    "该条动态不存在": "This feed is deleted",
    "该用户的地区暂未支持GIFTO礼物": "User's region currently doesn't support GIFTO gifts",
    "该用户的地区暂未支持此类型礼物": "User's region currently doesn't support this type of gifts",
    "该礼物只有达到VIP<%=value%>可以赠送": "This gift can only be sent with VIP<%=value%>",
    "该礼物赠送操作暂未开放，请下载Uplive App进行赠送": "This gift isn't open for sending yet, please download Uplive to send",
    "该等级已激活": "This level is activated",
    "该类型礼物需下载app赠送": "This type of gifts has to be send in app",
    "该邮箱未被注册": "This email hasn't been registered yet",
    "详情": "Learn more",
    "详情特权介绍": "Privilege details introduction",
    "说点什么吧": "Say something",
    "请不要发布重复内容": "Please do not post duplicate content",
    "请使用微信扫一扫<br/>扫描二维码支付": "Scan <br/> by WeChat to pay",
    "请先绑定手机号": "Please bind mobile number first",
    "请前往手机端Up直播 —> 个人中心 —> 我的直播 —> 收益提现 —> 绑定微信号": "Please open Uplive , Profile, My live stream, revenue is raised,bind wechat account",
    "请稍侯，正在登录中...": "Logging in, please wait...",
    "请输入20个字以内": "Please enter maximum 20 characters",
    "请输入Up号": "Enter Up account",
    "请输入密码": "Enter password",
    "请输入您要绑定的Paypal账号": "Please input your Paypal account",
    "请输入手机号码": "Please enter mobile no.",
    "请输入昵称": "Enter nickname",
    "请输入用户昵称或Up号": "Enter nickname or Up account",
    "请输入登录密码": "Please enter password",
    "请输入要绑定的手机号码": "Enter phone number",
    "请输入邮箱": "Please enter email address",
    "请输入验证码": "Enter verification code",
    "请输入验证码！": "Enter verification code",
    "贡献<%=count%>U币": "Sent <%=count%> coins",
    "财富榜": "Wealth board",
    "财富榜单": "Wealth Rank",
    "账号绑定": "Account bind",
    "账号被冻结，期间不能使用U钻送礼、发布弹幕等。如需解封，请联系VIP客服哦！": "Your account is frozen, you can not use U diamond to send gifts or send POP UP and so on. If you want to unlock, please contact VIP customer service!",
    "账户充值": "Account Recharge",
    "购买失败": "Purchase failed",
    "购买守护": "Buy Guardian Angel position",
    "贵宾坐席": "VIP seat",
    "贵宾坐席特权说明": "Exclusive VIP seat in chat rooms just for you!",
    "贵宾坐席获取条件": "VIP1 or higher",
    "赠送": "Send",
    "赠送了<%=count%>个<%=giftName%>": "sent <%=count%> <%=giftName%>",
    "赠送了<%=giftName%>": "Sent <%=giftName%>",
    "超出单次提现额度": "Exceed maximum withdraw limit",
    "超出当前格子能够赠送的数量": "Not enough space for gifts",
    "超清": "Ultra Definition",
    "超过当日提现次数": "Exceeded daily maximum withdrawal",
    "距上一名U币": "From last rank's uCoins",
    "距上一名U币<%=count%>": "From the last U coin <%=count%>",
    "距上一名U币<br/><%=count%>": "From the last U coin<br/> <%=count%>",
    "距离下一级：<%=code%>": "To next level: <%=code%>",
    "距离二维码过期还剩<%=count%>秒，过期后请刷新页面重新获取二维码": "The QR code will be expired in <%=count%> seconds, please refresh and get new QR code",
    "踢人次数": "Banned # users",
    "踢出会让这个用户在<%=time%>分钟内无法进入直播间": "Kicking this user out will keep him/her out of this room for <%=time%> minutes",
    "输入内容不能为空": "Content cannot be blank",
    "输入验证码": "Enter verification code",
    "达索Falcon900": "Dassault Falcon 900",
    "返回": "Back",
    "返回首页": "Return to homepage",
    "还没有人给你送礼，快去直播": "No one has sent you gift yet, go live stream!",
    "还没有关注？": "You're not following anyone yet?",
    "还没有粉丝？": "You don't have any followers yet?",
    "还没有给TA送礼，你不做第一个吗？": "No one has given gifts to host yet, you should be the first one!",
    "还没有评论，快来抢沙发吧！": "No comments yet, come be the first one!",
    "进入": "Enter",
    "进入房间失败": "Fail to enter this room",
    "进入直播间": "Tap to enter chat room",
    "进入直播间互动": "Enter stream to interact",
    "进入该直播间需要付费<%=count%>U钻，<br/>才能进入（已经支付过不会再扣除U钻）": "Entering this live stream requires entrance fee of <%=count%> diamonds <br/> (if already paid no additional payment needed)",
    "进场特效": "Special effect entrance",
    "进场特效特权说明": "VIP users enjoy grand entrance into the room unlike anyone else",
    "进场特效获取条件": "VIP1 or higher",
    "进房间隐身": "Invisible entrance ",
    "进房间隐身特权说明": "This feature is not avaible. Check back soon!",
    "进房间隐身获取条件": "VIP8 or higher",
    "进行中，剩余<%=count%>": "<%=count%> remaining",
    "连": "+1",
    "连接失败，请退出直播间重新进入": "Connection failed, try to quit and enter again.",
    "连接直播间超时": "Request overtime",
    "退出登录": "Log out",
    "送个礼物让主播开心一下吧！": "Surprise the host by sending a gift",
    "送出": "Sent",
    "选择国家或地区": "Select country or region",
    "遇见问题不用担心，专享客服为您服务。": "Exclusive custom service, standing by for all you questions",
    "邮箱未注册": "Email hasn't been registered yet",
    "邮箱未验证": "Check your mailbox to verify your email adress",
    "邮箱格式错误": "Wrong email format",
    "邮箱格式错误，请您重新输入！": "Wrong email adress, please check",
    "邮箱注册/登录": "Email Register / Login",
    "邮箱注册，不在白名单": "Registered email not in whitelist",
    "邮箱登录": "Email Login",
    "邮箱验证失败，请重试": "Verification failed, please try again",
    "邮箱验证次数超过每天限制": "\n verification times exceed daily limit",
    "醒目私信": "Highlighted private messages ",
    "醒目私信特权说明": "Being a VIP, each comment you make is highlighted, impossible to ignore!",
    "醒目私信获取条件": "VIP1 or higher ",
    "重新发送": "Resend",
    "重新登录": "Please login again",
    "金额小于最小提现额度": "Withdrawal amount cannot be less than <%=num%>",
    "金额或次数限充": "You have exceeded the daily limit",
    "金额超出今日提现额度": "You have exceeded the daily withdrawal limit",
    "锁屏": "Lock Screen",
    "防踢防禁言": "Message ban and removal immunity ",
    "防踢防禁言特权说明": "Prevent you from being banned to speak or removed from the room by anyone other than the host",
    "防踢防禁言获取条件": "VIP6 or higher",
    "阿斯顿·马丁DB9": "Aston Matin DB9",
    "随时关注喜欢的主播，就等你了！还不快来！": "Follow your favourite hosts anytime! What are you waiting for!",
    "非VIP": "Non-VIP",
    "页面标题": "Uplive Official Website - Uplive,live it up",
    "页面标题马甲包": "VIP Description",
    "预览": "Preview",
    "领取": "Take",
    "领取失败，请稍候重试": "Not received, please try again later",
    "领取时间": "Received time",
    "领取状态": "Received state",
    "领取礼物，随机获得不同金额U钻奖励": "Get the gift! You'll get a lucky amount of U diamonds!",
    "领取红包": "Withdraw lucky money",
    "领取记录": "Lucky money records",
    "领取金额": "Received amount",
    "首充优惠": "1st time recharge bonus",
    "首页": "Home",
    "马上和全球优质主播亲密互动": "Start interacting with international excellent hosts immediately",
    "验证码发送失败": "Failed to send verification code",
    "验证码已发送": "Verification code sent",
    "验证码输入错误": "Wrong verification code",
    "验证码错误！": "Incorrect verification code",
    "验证邮件已发送至<i><%=email%></i>请去邮箱确认": "Verification email has been sent to <i><%=email%></i>, please check",
    "验证邮件已重新发送": "Verification email resent done.",
    "验证邮箱": "Verify Email",
    "高清": "High Definition",
    "黑名单": "Blacklist",
    "（保级中）": "  (Maintaining level)",
    "（升级中）": "  (Leveling up)"
};


// WEBPACK FOOTER //
// ./js/lang/enus.js